// Filename - components/Sidebar/Sidebar.js


import React, { useState, useEffect, useRef, useCallback } from "react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import * as FaIcons from "react-icons/fa";
import * as AiIcons from "react-icons/ai";
import { SidebarData } from "./SidebarData";
import SubMenu from "./SubMenu";
import {SystemIcon} from '@workday/canvas-kit-react/icon';
import {plusCircleIcon, textEditIcon} from '@workday/canvas-system-icons-web';
import { IconContext } from "react-icons/lib";
import './Sidebar.scss';
import { Draggable } from "react-drag-reorder";

import {switchIcon} from '@workday/canvas-system-icons-web';


const Nav = styled.div`
    background: #fff;
    height: 80px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
`;


// The MENU toggle and the drawer's close control are buttons, not links:
// they open/close the drawer and never navigate (QA issue 14).
const NavButton = styled.button`
    margin-left: 2rem;
    font-size: 2rem;
    height: 80px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    background: none;
    border: none;
    padding: 0;
    color: inherit;
    cursor: pointer;
`;


// While closed the drawer is hidden (visibility) as well as moved off-screen,
// so its links are neither clickable nor reported as visible (QA issue 13).
const SidebarNav = styled.nav`
    background: #fff;
    width: 250px;
    height: 100vh;
    display: flex;
    justify-content: center;
    position: fixed;
    top: 0;
    left: ${({ $open }) => ($open ? "0" : "-100%")};
    visibility: ${({ $open }) => ($open ? "visible" : "hidden")};
    transition: left 350ms, visibility 350ms;
    z-index: 10;
`;


const SidebarWrap = styled.div`
    width: 100%;
`;


const Sidebar = () => {
    const [sidebar, setSidebar] = useState(false);
    const history = useHistory();
    const drawerRef = useRef(null);
    const toggleRef = useRef(null);


    const showSidebar = () => setSidebar(!sidebar);
    const closeSidebar = useCallback(() => setSidebar(false), []);

    // The drawer closes on Escape, on a click outside of it, and whenever the
    // route changes (an app link was clicked) - QA issue 2.
    useEffect(() => {
        if (!sidebar) return undefined;

        const onKeyDown = (e) => {
            if (e.key === "Escape") closeSidebar();
        };
        const onPointerDown = (e) => {
            const insideDrawer = drawerRef.current && drawerRef.current.contains(e.target);
            const onToggle = toggleRef.current && toggleRef.current.contains(e.target);
            if (!insideDrawer && !onToggle) closeSidebar();
        };
        document.addEventListener("keydown", onKeyDown);
        document.addEventListener("mousedown", onPointerDown);
        document.addEventListener("touchstart", onPointerDown);
        return () => {
            document.removeEventListener("keydown", onKeyDown);
            document.removeEventListener("mousedown", onPointerDown);
            document.removeEventListener("touchstart", onPointerDown);
        };
    }, [sidebar, closeSidebar]);

    useEffect(() => history.listen(() => closeSidebar()), [history, closeSidebar]);


    const [drag, setDrag] = useState(false);
    const [started, setStarted] = useState(false);

    const switchDrag = () => {

        setStarted(true);

        if (drag) {
            for (let i = 0; i < document.getElementsByClassName("grabbable").length; i++) {
                let element = document.getElementsByClassName("grabbable")[i];
                element.draggable = false;
                element.firstChild.classList.remove("drag-sb");
            }

        } else {
            for (let i = 0; i < document.getElementsByClassName("grabbable").length; i++) {
                let element = document.getElementsByClassName("grabbable")[i];
                element.draggable = true;
                element.firstChild.classList.add("drag-sb");
            }
        }
        setDrag(!drag);
    }

    return (
        <>
            <IconContext.Provider value={{ color: "#000000"}}>
                <Nav style={{marginLeft:"0px", height: "30px"}}>
                    <NavButton
                        type="button"
                        ref={toggleRef}
                        className="menu-toggle"
                        aria-label="Menu"
                        aria-haspopup="true"
                        aria-expanded={sidebar}
                        aria-controls="app-menu-drawer"
                        onClick={showSidebar}
                        style={{marginLeft:"0px"}}
                    >
                        <FaIcons.FaBars
                            style={{marginLeft:"0px", height: "21px"}}
                        />
                        <span style={{fontSize: ".8rem", letterSpacing: ".1rem", marginLeft: "0.4rem"}}>MENU</span>
                    </NavButton>
                </Nav>
                <SidebarNav
                    id="app-menu-drawer"
                    ref={drawerRef}
                    $open={sidebar}
                    aria-hidden={!sidebar}
                    aria-label="Apps menu"
                    style={{width: "27.6vw"}}
                >
                    <SidebarWrap>
                        <div className="flex-container" style={{marginTop: "3.58vh", marginBottom: "6.05vh"}}>
                            <div className="menu-text"><p>Menu</p></div>
                            <div>
                                <NavButton
                                    type="button"
                                    aria-label="Close menu"
                                    onClick={closeSidebar}
                                    style={{height: "10px"}}
                                >
                                    <AiIcons.AiOutlineClose
                                        style={{marginRight: "1.89vw", marginLeft: "auto", fontSize: "large"}}
                                    />
                                </NavButton>
                            </div>
                        </div>
                        <div className="flex-container" style={{marginLeft: "1.33vw", fontSize: "15px"}}>
                            <div className="vflex-container">
                                <p style={{color: "#4967ae"}}>Apps</p>
                                <div className="trapezoid"/>
                            </div>
                            <div className="vflex-container" style={{marginRight: "15.22vw"}}>
                                <p style={{color: "gray"}}>Shortcuts</p>
                                <div className="trapezoid" style={{background: "white"}}></div>
                            </div>
                        </div>
                        <hr style={{height: "1px", color: "gray"}}></hr>
                        <div className='orderAndSwitch' style={{marginLeft: "1.11vw", marginRight: "1.11vw", marginTop: "4.48vh", marginBottom: "4.8vh"}}>
                            <p style={{color: "#9e9fa2", fontSize: "13px"}}>Your Saved Order</p>
                            <button type="button" aria-label="Reorder apps" onClick={() => {
                                switchDrag()
                            }}>
                                <SystemIcon
                                    className='switchIcon'
                                    icon={switchIcon}
                                />
                            </button>
                        </div>

                        {/*

                            Draggable Re-order

                        */}


                        {started ? (
                            <Draggable>
                                {SidebarData.map((item, index) => {
                                    return (
                                        <div className='drag-sb subMenuItem' key={index}>
                                            <SubMenu
                                                item={item}
                                                onNavigate={closeSidebar}
                                            />
                                        </div>
                                    );
                                })}
                            </Draggable>
                        ) : (
                            <div>
                                {SidebarData.map((item, index) => {
                                    return (
                                        <div className='subMenuItem' key={index}>
                                            <SubMenu
                                                item={item}
                                                onNavigate={closeSidebar}
                                            />
                                        </div>
                                    );
                                })}
                            </div>
                        )}

                        {/* Draggable End
                        */}

                        <div style={{position:"absolute", background: "white", bottom:"1.68vh", width: "-webkit-fill-available"}}>
                            <div style={{height: "2.5px", backgroundColor: "#f5f3f5"}}></div>
                            <div className="flex-container" style={{marginLeft: "4.77vw", fontSize: "14px", marginTop: "3.15vh"}}>
                                <div className="app-mod" style={{width: "9.72vw", height: "5.94vh", borderRadius: "100vw", borderStyle: "solid", borderWidth: "2px"}}>
                                    <SystemIcon icon={plusCircleIcon} color='#4a5561'/>
                                    <p style={{color: "#4f4e4f", marginLeft: "0.67vw"}}>Add Apps</p>
                                </div>
                                <div className="app-mod" style={{marginRight: "5.06vw", width: "6.94vw", height: "5.94vh", borderRadius: "100vw", borderStyle: "solid", borderWidth: "2px"}}>
                                    <SystemIcon icon={textEditIcon} color='#4a5561'/>
                                    <p style={{color: "#4f4e4f", marginLeft: "0.67vw"}}>Edit</p>
                                </div>
                            </div>
                        </div>
                    </SidebarWrap>
                </SidebarNav>
            </IconContext.Provider>
        </>
    );
};


export default Sidebar;
